// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file entity/result_category.proto (package entity, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * ResultCategory構造体
 *
 * @generated from message entity.ResultCategory
 */
export class ResultCategory extends Message<ResultCategory> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * @generated from field: int32 display_order = 4 [json_name = "display_order"];
   */
  displayOrder = 0;

  /**
   * @generated from field: string thumbnail_url = 5 [json_name = "thumbnail_url"];
   */
  thumbnailUrl = "";

  /**
   * @generated from field: bool is_enabled = 6 [json_name = "is_enabled"];
   */
  isEnabled = false;

  /**
   * @generated from field: string environment = 7;
   */
  environment = "";

  /**
   * @generated from field: google.protobuf.Timestamp create_date = 8 [json_name = "create_date"];
   */
  createDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_date = 9 [json_name = "update_date"];
   */
  updateDate?: Timestamp;

  /**
   * @generated from field: string version = 10;
   */
  version = "";

  constructor(data?: PartialMessage<ResultCategory>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "entity.ResultCategory";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "display_order", jsonName: "display_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "thumbnail_url", jsonName: "thumbnail_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "is_enabled", jsonName: "is_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "environment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "create_date", jsonName: "create_date", kind: "message", T: Timestamp },
    { no: 9, name: "update_date", jsonName: "update_date", kind: "message", T: Timestamp },
    { no: 10, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ResultCategory {
    return new ResultCategory().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ResultCategory {
    return new ResultCategory().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ResultCategory {
    return new ResultCategory().fromJsonString(jsonString, options);
  }

  static equals(a: ResultCategory | PlainMessage<ResultCategory> | undefined, b: ResultCategory | PlainMessage<ResultCategory> | undefined): boolean {
    return proto3.util.equals(ResultCategory, a, b);
  }
}

